import React, { lazy } from 'react';
import { useGeoPrice } from '../hooks/useGeoPrice';
export function FooterCTA() {
  const {
    current,
    currency,
    loading
  } = useGeoPrice();
  return <footer className="py-24 bg-black border-t border-white/10 text-center relative overflow-hidden" data-id="element-66">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-purple-900/20 blur-[120px] rounded-full pointer-events-none" data-id="element-67" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-68">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-6 max-w-4xl mx-auto tracking-tight" data-id="element-69">
          Dejá de perder plata en creativos que no venden
        </h2>
        <p className="text-gray-400 mb-10 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-70">
          +100 creativos que convierten en menos de 10 minutos
        </p>

        <a href="#pricing" className="inline-block bg-white text-black hover:bg-gray-200 font-bold text-xl py-5 px-12 rounded-full shadow-[0_0_40px_rgba(255,255,255,0.3)] transform hover:-translate-y-1 transition-all duration-300 mb-8" data-id="element-71">
          ACCEDER A LA APP →
        </a>

        <p className="text-sm text-gray-500 mb-16 font-medium" data-id="element-72">
          {loading ? '$57 USD' : `$${current} ${currency}`} · Garantía 72hs
        </p>

        <div className="flex flex-col items-center gap-4" data-id="element-73">
          <img src="https://cdn.magicpatterns.com/uploads/oTx46CWhekMbGtneQivY5E/Gemini_Generated_Image_4pf4504pf4504pf4.jpg" alt="100ads" width="40" height="40" loading="lazy" decoding="async" className="w-10 h-10 rounded-xl object-cover opacity-60 hover:opacity-100 transition-opacity" data-id="element-74" />
          <div className="text-xs text-gray-700" data-id="element-75">
            &copy; {new Date().getFullYear()} 100ads. Todos los derechos
            reservados.
          </div>
        </div>
      </div>
    </footer>;
}